import { LotteryCountdown } from "./lottery-countdown";
import "odometer";
import { Lottery } from "@sazka/lotteries/js/models/lottery";

export class LotteryCountdownOdometer extends LotteryCountdown {
    private odometers: NodeListOf<HTMLElement>;
    private labels: HTMLElement[];

    constructor(parentEl: HTMLElement) {
        const game = window.environment.game;
        const config = {
            days:
                [
                    Lottery.sportka,
                    Lottery.eurojackpot,
                    Lottery.euromiliony,
                    Lottery.sazkaMobil,
                    Lottery.extraRenta,
                    Lottery.totoSazka,
                ].indexOf(game) >= 0,
            hours:
                [
                    Lottery.sportka,
                    Lottery.eurojackpot,
                    Lottery.euromiliony,
                    Lottery.sazkaMobil,
                    Lottery.extraRenta,
                    Lottery.totoSazka,
                    Lottery.stastnych10,
                    Lottery.kasicka,
                    Lottery.stastneDatum,
                    Lottery.miniRenta,
                ].indexOf(game) >= 0,
            minutes:
                [
                    Lottery.sportka,
                    Lottery.eurojackpot,
                    Lottery.euromiliony,
                    Lottery.sazkaMobil,
                    Lottery.extraRenta,
                    Lottery.totoSazka,
                    Lottery.stastnych10,
                    Lottery.kasicka,
                    Lottery.stastneDatum,
                    Lottery.keno,
                    Lottery.kameny,
                    Lottery.miniRenta,
                ].indexOf(game) >= 0,
            seconds: [Lottery.stastnych10, Lottery.keno, Lottery.kameny, Lottery.miniRenta].indexOf(game) >= 0,
        };
        super(config);

        this.createCalendarIcons(parentEl, config);
        this.odometers = parentEl.querySelectorAll(".start-odometer");
        this.labels = [
            ...parentEl.querySelectorAll<HTMLElement>(".calendar-icon-label, .calendar-card__bottom--countdown"),
        ];
    }

    DomRender() {
        const getTotalHours = this.units.indexOf("days") < 0;

        this.units.forEach((unit, i) => {
            const unitText = this.getUnitText(unit, getTotalHours);
            this.odometers[i].innerText = unitText.toString();
            this.labels[i].innerText = this.localizeLabel(unit, unitText);
        });
    }

    private createCalendarIcons(parentEl: HTMLElement, config: Record<string, unknown>) {
        const cnt = Object.values(config).filter((e) => e == true).length - 1;

        const child = parentEl.querySelector(".calendar-icon, .calendar-card--countdown");
        for (let i = 0; i < cnt; i++) {
            parentEl.appendChild(child.cloneNode(true));
        }
    }
}
